const SHELL_CHROME_SELECTORS = ['aui-header', 'ipua-panel', 'notifications-panel'];

// AvaApp's shell renders the masthead (<aui-header>), the ipua chat widget (<ipua-panel>), and
// the notifications bell (<notifications-panel>) from its own scripts, outside this app's
// control and in parallel with this bundle - none is guaranteed to exist in the DOM yet when
// this runs (the same race hideHeaderUrlInQa in lib/aui-header.ts works around with a polling
// retry). A MutationObserver catches whichever element wins that race instead of polling, and
// keeps catching it for as long as this page stays mounted.
//
// notifications-panel assumes an authenticated user and, without one, retries fetching an
// access token indefinitely, spamming the console with auth errors - it needs to go for the
// same reason aui-header/ipua-panel do: this page is unauthenticated by design.
//
// No restore on cleanup: this route only ever exits via a full page navigation (see
// AviatorCrushLanding/LeadForm - every exit sets window.location.href), so there's no case
// where the shell chrome needs to reappear without a fresh document to begin with.
export const hideShellChrome = (): (() => void) => {
  const removeExisting = () => {
    for (const selector of SHELL_CHROME_SELECTORS) {
      document.querySelector(selector)?.remove();
    }
  };

  removeExisting();

  const observer = new MutationObserver(removeExisting);
  observer.observe(document.body, { childList: true, subtree: true });

  return () => observer.disconnect();
};
